<template>
  <b-sidebar
    id="addAppointmentModal"
    title="Add New Appointment"
    backdrop
    class="customSidebar"
  >
    <div class="row p-3 h-100 w-100">
      <template>
        <div class="col-8">
          <div class="row mb-2">
            <div class="col-12">
              <div class="d-flex w-100 flex-column">
                <label class="h5">Outlet</label>
                <multiselect
                  v-model="appointmentForm.outlet"
                  label="text"
                  track-by="id"
                  :options="outlets"
                  placeholder="Select Outlet"
                  :searchable="true"
                  :show-labels="false"
                  :allow-empty="false"
                  openDirection="below"
                  @select="outletSelect"
                  class="w-100"
                >
                  <template slot="option" slot-scope="{ option }">{{
                    option.text
                  }}</template>
                  <span slot="noResult">{{
                    $t("table.no_records")
                  }}</span></multiselect
                >
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-6">
              <div class="d-flex flex-column">
                <label class="h5">Member Mobile</label>
                <multiselect
                  v-model="appointmentForm.member"
                  placeholder="Select/Create member"
                  label="mobile"
                  track-by="memberID"
                  :taggable="true"
                  @tag="addMember"
                  :multiple="false"
                  :tagPlaceholder="'Enter to create member'"
                  :options="members"
                  :searchable="true"
                  :show-labels="false"
                  :allow-empty="false"
                  :custom-label="mobileWithName"
                  @select="selectMember"
                  openDirection="below"
                  class="w-100"
                >
                  <!-- <template slot="option" slot-scope="{ option }">{{
                    option.mobile
                  }}({{option.name}})</template> -->
                  <span slot="noResult">{{
                    $t("table.no_records")
                  }}</span></multiselect
                >
              </div>
            </div>
            <div class="col-6">
              <div class="d-flex flex-column">
                <label class="h5">Member Name</label>
                <b-form-input
                  v-model="appointmentForm.member.name"
                ></b-form-input>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-6">
              <label class="h5">Date</label>
              <b-form-input v-model="appointmentForm.arrivalDate" type="date"></b-form-input>
            </div>
            <div class="col-6">
              <label class="h5">Time</label>
              <b-form-select
                v-model="appointmentForm.time"
                :disabled="appointmentForm.staff == null"
                :options="timeSlots.length === 0 ? timeOptions:timeSlots"
              ></b-form-select>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <div class="d-flex flex-column">
                <label class="h5">Staff</label>
                <b-form-input @input="searchStaff" placeholder="Search Staff"></b-form-input>
                <div
                  class="card w-100 p-2 d-flex flex-row"
                  style="height: 80px;overflow-x:scroll"
                >
                  <b-button
                    v-for="(s, index) in staffs"
                    :key="index"
                    class="col-3 text-truncate mr-1"
                    size="sm"
                    pill
                    :variant="appointmentForm.staff === s ? 'success':'outline-success'"
                    @click="staffAvailability(s)"
                    ><b-avatar
                      :src="s.image != '' ? s.image : s.icon"
                      
                      size="2rem"
                      class="mx-1"
                    ></b-avatar
                    >{{ s.name }}</b-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-6 d-flex flex-column">
                <label class="h5">Service</label>
                <select v-model="appointmentForm.sku" class="form-control">
                    <option v-for="(i,index) in skuList" :key="index" :value="i.skuID">{{i.name}}</option>
                </select>
            </div>
          </div>
          <div class="row">
                        <div class="col-8 d-flex justify-content-center flex-column">
                <label class="h5">Duration</label>
                <div class="d-flex">
                  <b-button variant="outline-secondary" @click="mutateDuration(-15)">-60 min</b-button>
                  <b-button variant="outline-secondary" class="mx-1" @click="mutateDuration(-30)">-30 min</b-button>
                    <b-button variant="outline-secondary" @click="mutateDuration(-15)">-15 min</b-button>
                    <b-form-input v-model="appointmentForm.duration" class="mx-1 h-100"></b-form-input>
                    <b-button variant="outline-secondary" @click="mutateDuration(15)">+15 min</b-button>
                    <b-button variant="outline-secondary" class="mx-1" @click="mutateDuration(30)">+30 min</b-button>
                  <b-button variant="outline-secondary" @click="mutateDuration(60)">+60 min</b-button>
                </div>
            </div>
          </div>
        </div>
      </template>
      <div class="col-4 border-left">
        <div class="d-flex justify-content-between">
          <h2>Appointment Details</h2>
          <!-- <b-button
            :active="toggle"
            variant="outline-primary"
            class="link"
            @click="toggle = !toggle"
            pill
            size="xs"
            >Toggle</b-button
          > -->
        </div>
        <div
          class="d-flex"
          :class="toggle ? 'flex-column' : 'justify-content-between'"
        >
          <label class="h5 mb-0">Date:</label>
          <span>{{ formatDate(appointmentForm.arrivalDate,"DD MMM YYYY")}} {{appointmentForm.time}}</span>
        </div>
        <div
          class="d-flex mt-3"
          :class="toggle ? 'flex-column' : 'justify-content-between'">
          <label class="h5 mb-0">Outlet:</label>
          <span>{{appointmentForm.outlet != null ? appointmentForm.outlet.bizName:'-'}}</span>
        </div>
        <div
          class="d-flex mt-3"
          :class="toggle ? 'flex-column' : 'justify-content-between'"
        >
          <label class="h5 mb-0">Member:</label>
          <span>{{appointmentForm.member != null ? appointmentForm.member.name: '-'}}</span>
        </div>
        <div
          class="d-flex mt-3"
          :class="toggle ? 'flex-column' : 'justify-content-between'"
        >
          <label class="h5 mb-0">Staff:</label>
          <span>{{appointmentForm.staff != null ? appointmentForm.staff.name : '-'}}</span>
        </div>
        <div
          class="d-flex mt-3"
          :class="toggle ? 'flex-column' : 'justify-content-between'"
        >
          <label class="h5 mb-0">Service:</label>
          <span>{{appointmentForm.sku != null ? appointmentForm.sku: '-'}}</span>
        </div>
        <div
          class="d-flex mt-3"
          :class="toggle ? 'flex-column' : 'justify-content-between'"
        >
          <label class="h5 mb-0">Duration:</label>
          <span>{{appointmentForm.duration == 0 ? '-':appointmentForm.duration}} minute(s)</span>
        </div>
        <div
          class="d-flex mt-3"
          :class="toggle ? 'flex-column' : 'justify-content-between'"
        >
          <label class="h5 mb-0">Color:</label>
          <div
            class="
              card
              d-flex
              text-center
              justify-content-center
              p-2
              flex-column
            "
          >
            <div
              style="height: 40px;width:60px; border-radius: 5px"
              :style="`background-color:${appointmentForm.color.hex};`"
            ></div>
              {{appointmentForm.color.color}}
          </div>
        </div>
      </div>
    </div>
    <template #footer="{ hide }">
      <div class="d-flex bg-light text-light justify-content-end px-3 py-2">
        <b-button class="mr-2" size="sm" @click="hide">Close</b-button>
        <b-button variant="primary" @click="createAppt()">Save</b-button>
      </div>
    </template>
  </b-sidebar>
</template>
<script>
import Swal from 'sweetalert2';
import { handleSessionExpired, idbOpen, toastrExe } from '../../../../assets/js/dashboard/dashboard';
import moment from "moment";
export default {
  name: "AddAppointmentModal",
  props: {
    sku: Array,
  },
  watch: {
    sku() {
      this.skuList = this.$props.sku;
    },
  },
  data() {
    return {
      appointmentForm: {
        outlet: null,
        arrivalDate: null,
        time: null,
        staff:null,
        member:{
          name:"",
          mobile:""
        },
        sku: null,
        color:{
          hex:"",
          color:""
        },
        blocked:0,
        duration:0
      },
      outlets: [],
      timeSlots: [],
      staffs: [],
      staffsClone:[],
      skuList: [],
      colorList:[],
      toggle: false,
      db: null,
      members:[],
      addFlag:false
    };
  },
  methods: {
    async addMember(event){
      this.addFlag = true;
      this.appointmentForm.member = {
        mobile:event,
        name:"New Member"
      }
      this.members.push({
        mobile:event,
        name:"New"
      })
    },
    selectMember(event){
      this.addFlag = false;
      this.appointmentForm.member = event;
    },
    async staffAvailability(event){
      this.appointmentForm.staff = event;
      this.timeSlot = [];
      let $vm = this;
      let result = [];
      let leFormattedDate = moment(this.appointmentForm.arrivalDate).format("DD-MM-YYYY");
      let url = this.$api.STAFF+"/" + event.staffID+"/slots/"+leFormattedDate;
      await $vm.$axios({
        method: "get",
        url: url,
        baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: $vm.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.slots;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
        result.forEach(element=>{
          if(element.blockDate === 0){
            element.slotDate = moment(new Date(element.slotDate * 1000)).subtract(8,"hours").toDate();
          let hours = element.slotDate.getHours() < 10 ? "0"+element.slotDate.getHours().toString():element.slotDate.getHours();
          let minutes = element.slotDate.getMinutes() === 0 ? '00':element.slotDate.getMinutes();
          let formattedTime = `${hours}:${minutes}`;
          this.timeSlots.push(formattedTime);
          console.log(`${element.slotDate} equals to ${formattedTime}`)
          }
        })

    },
    mobileWithName ({ mobile,name }) {
      return `${mobile} — ${name}`
    },
    outletSelect(sel){
      this.appointmentForm.staff = null;
      this.staffs = this.staffsClone.filter(s=>{
        if(s.outletID == sel.id){
          return s;
        }
      })
    },
    mutateDuration(num){
      this.appointmentForm.duration=Number(this.appointmentForm.duration)+num;
    },
    getStaffList() {
      this.staffs = JSON.parse(this.$store.state.staffs);
      this.staffsClone = JSON.parse(this.$store.state.staffs);

    },
    async getColorList(){
      let url = "/colors";
      let $vm = this;
      let result = [];
        await this.$axios({
        method: "get",
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$session.get("token") },

      })
        .then(function (response) {
          result = response.data.colors;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

        this.colorList = result;

    },
    async getMemberData(){
      const tx = this.db.transaction("member_list", "readwrite");
      const store = tx.objectStore("member_list");
      const res = await store.get("key");
      return res;
    },
    searchStaff(val){
      this.staffs = this.staffsClone.filter(s=>{
        if(s.name.toUpperCase().includes(val.toUpperCase())){
          return s;
        }
      })
    },
    formatDate(date, format) {
      let formattedDate = moment(date).format(format);
      if(formattedDate == "Invalid date"){
        return "-";
      }
      else{
        return formattedDate;
      }
    },
    async createAppt(){
      let flag = false;
      let combinedDate = this.appointmentForm.arrivalDate+ " "+ this.appointmentForm.time;
      let formattedDate = moment(combinedDate).toDate();
      formattedDate = (formattedDate.getTime() / 1000);
      await Swal.fire({
        title: `Confirm save appointment?`,
        showCancelButton: true,
        confirmButtonText:"Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }

      let url = "https://member.tunai.io/business/member";
      let $vm = this;
      let result = [];
      if(this.addFlag){
        await this.$axios({
        method: "post",
        url: url,
        headers: { token: this.$session.get("token") },
        data:{
          name:$vm.appointmentForm.name,
          mobile:$vm.appointmentForm.mobile,
          outletID:$vm.appointmentForm.outlet.id
        }
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if(result.status === 200){
          toastrExe($vm,'New Member',`Successfully created member ${$vm.appointmentForm.member.name}`,'success');
        }
        else{
          toastrExe($vm,'New Member',`Failed to created member ${$vm.appointmentForm.member.name}`,'danger');
        }
      }
      url = "https://appt.tunai.io/business/book";
       await this.$axios({
        method: "post",
        url: url,
        headers: { token: this.$session.get("token") },
        data:{
          memberID: $vm.appointmentForm.member.memberID,
          outletID: $vm.appointmentForm.outlet.id,
          skuID: $vm.appointmentForm.sku,
          duration: Number($vm.appointmentForm.duration),
          colorID: 5,//$vm.appointmentForm.color,
          blocked: $vm.appointmentForm.blocked,
          arrivalDate: formattedDate,
          staffID: $vm.appointmentForm.staff.staffID }
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

        if(result.status === 200){
          toastrExe($vm,'New Appointment',`Successfully created appointment for ${$vm.appointmentForm.member.name}`,'success');
        }
        else{
          toastrExe($vm,'New Appointment',`Failed to created appointment for ${$vm.appointmentForm.member.name}`,'danger');
        }
    }
  },
  async mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets);
    this.skuList = this.$props.sku;
    let dbName = this.$store.state.userName+"_memberList";
    this.db = await idbOpen(dbName,"member_list");
    this.members = await this.getMemberData();
    this.getColorList();
    this.getStaffList();
  },
  computed: {
    timeOptions() {
      var quarterHours = ["00", "15", "30", "45"];
      var times = [];
      for (var i = 0; i < 24; i++) {
        for (var j = 0; j < 4; j++) {
          times.push(i + ":" + quarterHours[j]);
        }
      }
      return times;
    },
  },
};
</script>
<style>
#addAppointmentModal {
  top: 0 !important;
  bottom: 0 !important;
  height: 100vh !important;
  width: 100vw !important;
}
.vl {
  border-left: 2px solid black;
  height: 100px;
}
.colorBox{
  height:15px;
  width:20px;
}
</style>